/*
 * Drop down menu
 */
'use strict';

const $ = require("jquery");

let productLists = [];

jQuery(document).bind('gform_post_render', () => {

    const productRows = jQuery(".product_list .gfield_list .gfield_list_group");
    if (productRows) {
        jQuery.each(productRows, function (index, value) {
            productLists.push(new ProductList(value));
        });
    }

    const accessoryRows = jQuery(".accessory_list .gfield_list .gfield_list_group");
    if (accessoryRows) {
        jQuery.each(accessoryRows, function (index, value) {
            const row = new AccessoryRow(value);
        });
    }

    $('.gfield_list_42_cell1 select').prop('disabled', false);
    $('.gfield_list_42_cell2 select').prop('disabled', false);

    $('body').on('change', '.gfield_list_42_cell1 select', function(e) {
        const allowPitch = $(this).find('option:selected').attr('data-pitch');
        const row = $(this).parents('tr.gfield_list_group');

        if (allowPitch === 'enabled') {
            row.find('.gfield_list_42_cell3 input').css({
                opacity: 0.5,
            }).val('--').attr({
                readonly: 'readonly'
            });
        } else {
            row.find('.gfield_list_42_cell3 input').val('').removeAttr('readonly').css({
                opacity: 1
            });
        }
    });
});


function updateTrimOptions() {
    let productIds = [];
    for (let i = 0; i < productLists.length; i++) {
        const list = productLists[i];
        productIds.push(list.product);
    }

    // Trim select
    $('.gfield_list_42_cell1 select').empty().prop('disabled', false);

    // Color select
    $('.gfield_list_42_cell2 select').empty().prop('disabled', false).append('<option value="No Color Selected">-- Choose Color --</option>');

    for (let productListI = 0; productListI < productLists.length; productListI++) {
        const select = productLists[productListI].row.find('[class*="_cell2"] select');
        if (select.length) {
            let clonedChildren = select.children().clone();
            clonedChildren.splice(0, 1);
            $('.gfield_list_42_cell2 select').append(clonedChildren);
        }
    }

    $('.gfield_list_42_cell2 select').prop('disabled', false);

    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: "json",
        data: {
            action: 'get_trim_data',
            productIds: productIds
        },
        success: (data) => {
            if (data != null && data.trim && data.trim.length > 0) {
                const trimArray = data.trim;

                $('.gfield_list_42_cell1 select').append('<option value="No Trim Selected">-- Choose Trim --</option>');
                for (let trimI = 0; trimI < trimArray.length; trimI++) {
                    const trim = trimArray[trimI];
                    const pitch = (trim.pitch) ? 'enabled' : 'disabled';

                    let option = $('<option />');
                    option.attr('value', trim.name);
                    option.attr('data-pitch', trim.pitch);
                    option.html(trim.name);

                    $('.gfield_list_42_cell1 select').append(option);
                }
            } else {
                console.warn('Unable to get Trim data');
                $('.gfield_list_42_cell1 select').empty().append('<option value="No Trim Selected">-- No Trim Options --</option>');
            }

            $('.gfield_list_42_cell1 select').prop('disabled', false);
        },
        error: function (error) {
            console.warn(error);
        }
    });
}


class ProductList {
    row = null;
    productSelect = null;
    colorSelect = null;
    addButton = null;
    product = null;

    constructor(rowE) {
        this.row = $(rowE);
        this.productSelect = this.row.find(".gfield_list_39_cell1 select");
        this.colorSelect = this.row.find(".gfield_list_39_cell2 select");
        this.addButton = this.row.find(".gfield_list_icons .add_list_item");
        this.deleteButton = this.row.find(".gfield_list_icons .delete_list_item");

        if (!this.productSelect.find('option:last').attr('pid')) {
            this.productSelect.find("option").each(function () {
                $(this).attr('pid', $(this).val());
                $(this).val($(this).text());
            });
        }

        this.colorSelect.prop('disabled', false);

        this.addButton.click(() => {
            productLists.push(new ProductList(this.row.next('tr')));
        });

        this.deleteButton.click(() => {
            for (let i = 0; i < productLists.length; i++) {
                const product = productLists[i];
                if (product.product === this.product) {
                    productLists.splice(i, 1);
                }
            }

            this.updateOptions();
        });

        this.productSelect.change(() => {
            this.updateOptions();
        });
    }

    updateOptions() {
        this.product = $('option:selected', this.productSelect).attr('pid')

        this.deleteButton.attr('data-pid', this.product);

        $.ajax({
            context: this,
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                selectedproduct: this.product,
                action: 'get_product_data'
            },
            success: (data) => {
                if (data != null) {
                    this.colorSelect.prop('disabled', false).empty();
                    // $('.gfield_list_42_cell2 select').prop('disabled', false).empty();

                    let returned = $.parseJSON(data);

                    let blankOption = '<option value="No Color Selected">-- Choose Color --</option>';
                    this.colorSelect.append(blankOption);
                    // $('.gfield_list_42_cell2 select').append(blankOption);

                    if (returned.choices) {
                        for (let gauge = 0; gauge < returned.choices.length; gauge++) {
                            const group = returned.choices[gauge];

                            let newOptGroup = '<optgroup label="' + this.productSelect.val() + ' - ' + group.title + '">';
                            for (let color_i = 0; color_i < group.colors.length; color_i++) {
                                const color = group.colors[color_i];
                                newOptGroup += '<option value="' + group.title + ' - ' + color + '">' + color + '</option>';
                            }
                            newOptGroup += '</optgroup>';

                            this.colorSelect.append(newOptGroup);
                            // $('.gfield_list_42_cell2 select').append(newOptGroup);
                        }
                    }

                    this.colorSelect.prop('disabled', false);
                    // $('.gfield_list_42_cell2 select').prop('disabled', false);

                    updateTrimOptions();
                }
            },

            error: function (error) {
                console.warn(error);
            }
        });
    }
}


class AccessoryRow {
    row = null;
    itemSelect = null;
    optionSelect = null;
    addButton = null;
    accessory = null;

    constructor(rowE) {
        this.row = $(rowE);
        this.itemSelect = this.row.find(".gfield_list_41_cell1 select");
        this.optionSelect = this.row.find(".gfield_list_41_cell2 select");
        this.addButton = this.row.find(".gfield_list_icons .add_list_item");

        this.addButton.click(() => {
            const row = new AccessoryRow(this.row.next('tr'));
        });

        this.itemSelect.change(() => {
            this.updateOptions();
        });
    }

    updateOptions() {
        this.accessory = $('option:selected', this.itemSelect).val();

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: "json",
            data: {
                action: 'get_accessory_options',
                accessory: this.accessory
            },
            success: (data) => {
                this.optionSelect.empty().append('<option value="No Option Selected">-- Choose Option --</option>');
                if (data != null && data.choices && data.choices.length) {
                    for (let dataI = 0; dataI < data.choices.length; dataI++) {
                        const choice = data.choices[dataI];
                        this.optionSelect.append('<option value="'+choice+'">'+choice+'</option>');
                    }
                }
            },
            error: function (error) {
                console.warn(error);
            }
        });
    }
}
